import React from "react";
import addIcon from "../../../../../assets/images/DeathModuleNew/addIcon.png";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import moment from "moment";
import addNewIcon from "../../../../../assets/SVGs/add.svg";
import { setActiveStep } from "../../../../../redux/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "../../../disability/DisabilityDashboard/styles/disbilityDashboardStyle.css";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

export const DivorceDisplayCardListing = ({
  step,
  fileUpload,
  loading,
  documents,
  moduleData,
  width,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const moduleFieldMapping = {
    "Personal Information": ["Name",],
    "Debt & Liabilities": ["Nickname of Liabilities"],
    "Asset Documentation": ["Name of Asset"],
    "Income Information": ["Income Name","Net Amount"],
    "Child Custody Considerations": ["Visitation Schedule", ],
    "Professional Contacts": ["Name", ],
    "Business interests": ["Name",],
    "Professional Team": ["Name",],
    "Legal Documentation": ["Name", ],
    "Child Support Calculations": ["Educational Expenses","Education","Healthcare", "Transportation", "Childcare", "Activities" ],
  };

  return (
    <div
      className="DisabilityCardMain"
      style={{ position: "relative", width: width ? width : "" }}
    >
      <div className="cardHeadingDisability">
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          {moduleData.Icon && (
            <img
              width={66}
              height={56}
              src={moduleData.Icon}
              alt={moduleData.name}
            ></img>
          )}
          <div style={{ display: "flex", alignItems: "baseline", columnGap: "3px" }}>
          {moduleData.name}
          {moduleData &&
            moduleData.tooltip &&
            ["Personal Information", "Debt & Liabilities", "Asset Documentation", "Income Information", "Child Custody Considerations", "Business Interests", "Child Support Calculations"].includes(moduleData.name) && (
              <ToolTipCreator name={moduleData.tooltip} />
          )}
          </div>
        </div>
        <div className="uploadButtonsDisability">
          {" "}
          <div
            className="upload"
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              dispatch(setActiveStep(step));
              history.push("/protector/divorce");
            }}
          >
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      {moduleData.Purpose && (
        <div className="cardDisabilityDesc">{moduleData.Purpose}</div>
      )}

      <div className="cardHeadingDisability">
        {moduleData.detailsHeading ? moduleData.detailsHeading : "Details"}
      </div>
      <div
        style={{ maxHeight: "5rem", overflowY: "auto", paddingInline: "8px" }}
      >
        {documents && documents.length > 0 ? (
          documents.map((item, index) => {
            const fields = moduleFieldMapping[moduleData.name] || [
              "Name",
              "Value",
            ];
            const moduleName = moduleData.name;
            const isIncomeModule = moduleData.name === "Income Information";
            return (
              <div key={index} className="disabilityDashboardListingRow">
                <div className="checkListName">
                {isIncomeModule ? (
                  <div>{item[fields[0]] || "N/A"}</div>
                ) : moduleName === "Child Custody Considerations" ? (
                  <div>
                    {item["Visitation Schedule"]
                      ? moment(item["Visitation Schedule"]).format("dddd, MM/DD/YYYY")
                      : "N/A"}
                  </div>
                ) : (
                  fields.map((field, i) => (
                    <div key={i}>
                      {item[field] || "N/A"}
                    </div>
                  ))
                )}
                </div>
                <div
                  className="emailStatus"
                  style={{ background: "transparent", width: "fit-content" }}
                >
                {isIncomeModule ? (
                  <span>
                    {item[fields[1]]
                      ? "$" +
                        Number(item[fields[1]]).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                        })
                      : "N/A"}
                  </span>
                ) : (
                  <img src={addNewIcon} alt="addNew" />
                )}
                </div>
              </div>
            );
          })
        ) : (
          <div style={{ padding: "0.5rem", color: "#999" }}>
            No data to show
          </div>
        )}
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
